import React from 'react';
import { RouteComponentProps } from 'react-router';

import { BubbleButton } from '@go-client/components/BubbleUI';
import Page from './Page';

import './CheckGOVersion.scss';
import { readQs } from '@go-shared/lib/querystring';
import { usePublicServerInfo } from '@go-client/context/PublicServerInfoContext';
import { resolveHomePath } from '@go-client/routes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * Return either the string value of `redirectFrom` in the QS, or HOME_PATH
 */
function getRedirectionUrl(): string {
  let redirectFrom = readQs().redirectFrom;
  if (!redirectFrom || typeof redirectFrom !== 'string') {
    return resolveHomePath();
  }
  return redirectFrom;
}

export default function OutdatedVersion(_: RouteComponentProps<{}>) {
  let redirectFrom = getRedirectionUrl();

  const { goVersion: serverGOVersion } = usePublicServerInfo();
  const clientGOVersion = __VERSION;

  const outdated = clientGOVersion !== serverGOVersion;

  return (
    <Page className="MaintenanceModePage">
      <div className="h-full grid items-center justify-center">
        <div className="shadow-xl" style={{ width: '400px' }}>
          <div className="aspect-wide bg-ocean logo"></div>
          <div className="p-8 bg-white">
            <div className="flex items-center text-xl mb-3">
              <h1 className="mr-3">GO Version Checker</h1>
              <FontAwesomeIcon
                icon={outdated ? 'circle-xmark' : 'circle-check'}
                className={`ml-auto ${outdated ? 'text-crimson' : 'text-lime'}`}
              />
            </div>
            <div>
              <p>
                <b>Current:</b> {clientGOVersion}
              </p>
              <p className="mb-3">
                <b>Actual:</b> {serverGOVersion}
              </p>
            </div>
            <div className="bg-eggshell border rounded px-4 py-3 mb-5">
              {outdated ? (
                <p>
                  The version of GO on this browser (current) is not up to date with the version of
                  GO on the server (actual). To fix this, please refresh this page by clicking the
                  refresh button on your browser or by using the refresh button below.
                </p>
              ) : (
                <p>
                  The version of GO on this browser (current) is up to date with the version of GO
                  on the server (actual). No further action is necessary. Click <i>Go Back</i> to
                  visit the previous page, or <i>Go Home</i> to return to the main menu.
                </p>
              )}
            </div>
            {outdated ? (
              <div>
                <BubbleButton variant="navy" onClick={() => location.reload()} icon="rotate-left">
                  Reload and Try Again
                </BubbleButton>
              </div>
            ) : (
              <div>
                <BubbleButton variant="navy" icon="arrow-left">
                  <a href={redirectFrom} className="stretched-link">
                    Go Back
                  </a>
                </BubbleButton>
                <BubbleButton variant="slate" inverse icon="home">
                  <a href="/" className="stretched-link">
                    Go Home
                  </a>
                </BubbleButton>
              </div>
            )}
          </div>
        </div>
      </div>
    </Page>
  );
}
